export default __webpack_public_path__ + "static/media/img-founders-collection-mobile.19b0095b.png";